var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export default function DropDown(props) {
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    useEffect(function () {
        document.addEventListener("click", handleClick);
        return function () {
            document.removeEventListener("click", handleClick);
        };
    });
    function handleClick(e) {
        var clickedElement = e.target;
        if (clickedElement instanceof Element &&
            clickedElement.id !== "dropdown-".concat(props.id) &&
            clickedElement.id !== "dropdown-".concat(props.id, "-child") &&
            !clickedElement.closest("#dropdown-".concat(props.id))) {
            setIsVisible(false);
        }
    }
    return (_jsxs("div", __assign({ className: "".concat(props.className, " relative") }, { children: [_jsx("button", __assign({ id: "dropdown-".concat(props.id), className: "p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200 flex items-center justify-center", onClick: function () { return setIsVisible(!isVisible); }, "aria-label": "Menu" }, { children: isVisible ? (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pointer-events-none text-gray-600" }, { children: _jsx("path", { d: "M6 18L18 6M6 6l12 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }) }))) : (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pointer-events-none text-gray-600" }, { children: _jsx("path", { d: "M3 12h18M3 6h18M3 18h18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }) }))) })), _jsx("div", __assign({ id: "dropdown-".concat(props.id, "-child"), className: "dropdown-".concat(props.id, " ").concat(!isVisible && "hidden", " absolute right-0 z-50 shadow-lg rounded-2xl bg-white min-w-[200px] mt-2") }, { children: _jsx("div", __assign({ className: 'flex flex-col px-2 py-1 gap-y-2' }, { children: props.children })) }))] })));
}
